import { render } from "./ConfigurableRows.vue?vue&type=template&id=407908d6"
import script from "./ConfigurableRows.vue?vue&type=script&lang=ts"
export * from "./ConfigurableRows.vue?vue&type=script&lang=ts"
script.render = render

export default script